import { NgModule } from "@angular/core";
import { LoginComponent } from "./account/login/login.component";
import { PasswordResetComponent } from "./account/password-reset/password-reset.component";
import { AccountComponent } from "./account/account";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { RouterModule, Routes } from "@angular/router";
import { BillComponent } from "./bill/bill.component";
import { BaseComponent } from "./layout/base/base.component";
import { CreateBillTypeComponent } from "./bill/create-bill-type/create-bill-type.component";
import { ManageBillTypeComponent } from "./bill/manage-bill-type/manage-bill-type.component";
import { ViewBillTypeComponent } from "./bill/view-bill-type/view-bill-type.component";
import { AuthGuard } from "./shared/services/guards/auth.guard";
import { SetUpBillTypeComponent } from "./bill/set-up-bill-type/set-up-bill-type.component";
import { PaymentLogComponent } from "./bill/payment-log/payment-log.component";
import { PaymentVerificationComponent } from "./bill/payment-verification/payment-verification.component";
import { SelectCommunityComponent } from "./bill/select-community/select-community.component";
import { OutstandingBillsComponent } from "./bill/outstanding-bills/outstanding-bills.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { AdministratorComponent } from "./administrator/administrator.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { CommunityManagementComponent } from "./community-management/community-management.component";
import { CommunityCardsComponent } from "./community-management/community-cards/community-cards.component";
import { CommunityResourcesComponent } from "./community-management/community-resources/community-resources.component";
import { PropertyManagementComponent } from "./property-management/property-management.component";
import { UnitManagementComponent } from "./unit-management/unit-management.component";
import { RemindersComponent } from "./bill/reminders/reminders.component";
import { ResidentManagementComponent } from "./resident-management/resident-management.component";
import { NoticeBoardComponent } from "./notice-board/notice-board.component";
import { PollsComponent } from "./polls/polls.component";
import { ViewPollComponent } from "./polls/view-poll/view-poll.component";
import { BillManagementComponent } from "./community-management/bill-management/bill-management.component";
import { BasicComponent } from "./basic/basic.component";
import { LocationComponent } from "./basic/location/location.component";
import { TermsComponent } from "./terms/terms.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";

const routes: Routes = [
  {
    path: "account",
    component: AccountComponent,
    children: [
      {
        path: "",
        redirectTo: "login",
        pathMatch: "full"
      },
      {
        path: "login",
        component: LoginComponent
      },
      {
        path: "reset-password",
        component: PasswordResetComponent
      }
    ]
  },
  {
    path: "terms-and-conditions",
    component: TermsComponent
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent
  },
  {
    path: "",
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "dashboard/r/0",
        pathMatch: "full"
      },
      {
        path: "dashboard/r/:index",
        component: DashboardComponent
      },
      {
        path: "bill-types/r/:index",
        component: BillComponent
      },
      {
        path: "bill-types/r/:index/create",
        component: CreateBillTypeComponent
      },
      {
        path: "bill-types/r/:index/manage",
        component: ManageBillTypeComponent
      },
      {
        path: "bill-types/r/:index/:billTypeId",
        component: ViewBillTypeComponent
      },
      {
        path: "bill-types/r/:index/:communityId/:billTypeId/setup",
        component: SetUpBillTypeComponent
      },
      {
        path: "payments/communities/r/:index",
        component: SelectCommunityComponent
      },
      {
        path: "payments/r/:index",
        component: PaymentLogComponent
      },
      {
        path: "payments/r/:index/:communityId",
        component: PaymentLogComponent
      },
      {
        path: "payment-verification-requests/r/:index",
        component: PaymentVerificationComponent
      },
      {
        path: "reminders/r/:index",
        component: RemindersComponent
      },
      {
        path: "bills/outstanding/r/:index",
        component: OutstandingBillsComponent
      },
      {
        path: "notifications/r/:index",
        component: NotificationsComponent
      },
      {
        path: "administrators/r/:index",
        component: AdministratorComponent
      },
      {
        path: "profile/r/:index",
        component: UserProfileComponent
      },
      {
        path: "communities/r/:index",
        component: CommunityManagementComponent
      },
      {
        path: "communities/:communityId/r/:index",
        component: CommunityCardsComponent
      },
      {
        path: "communities/:communityId/resources/r/:index",
        component: CommunityResourcesComponent
      },
      {
        path: "communities/:communityId/properties/r/:index",
        component: PropertyManagementComponent
      },
      {
        path: "communities/:communityId/bills/r/:index",
        component: BillManagementComponent
      },
      {
        path: ":communityId/properties/:propertyId/units/r/:index",
        component: UnitManagementComponent
      },
      {
        path: ":communityId/:propertyId/units/:unitId/residents/r/:index",
        component: ResidentManagementComponent
      },
      {
        path: "notice-board/r/:index",
        component: NoticeBoardComponent
      },
      {
        path: "polls/r/:index",
        component: PollsComponent
      },
      {
        path: "poll/r/:index/:pollId",
        component: ViewPollComponent
      },
      {
        path: "basic/r/:index",
        component: BasicComponent
      },
      {
        path: "basic/location/r/:index",
        component: LocationComponent
      },
      {
        path: "basic/location/:type/r/:index",
        component: LocationComponent
      },
      {
        path: "basic/location/:type/:country/r/:index",
        component: LocationComponent
      },
      {
        path: "basic/location/:type/:country/:state/r/:index",
        component: LocationComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts